import React from 'react';
import { Box } from '@mui/material';

export default function Map() {
  return (
    <Box component="section" sx={{ py: 0 }}>
      <Box sx={{ width: '100%', height: 450 }}>
        <iframe
          src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3691.52!2d70.77539787473599!3d22.27413119980414!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0%3A0x0!2zMjLCsDE2JzI2LjkiTiA3MMKwNDYnMzEuNCJF!5e0!3m2!1sen!2sin!4v1234567890123!5m2!1sen!2sin&q=22.27413119980414,70.77539787473599"
          width="100%"
          height="100%"
          style={{ border: 0 }}
          allowFullScreen
          loading="lazy"
          referrerPolicy="no-referrer-when-downgrade"
          title="SHREE CONSULTANCY Office Location"
        />
      </Box>
    </Box>
  );
}